import { render, staticRenderFns } from "./NoDeliveryContent.vue?vue&type=template&id=cc22a674&"
import script from "./NoDeliveryContent.vue?vue&type=script&lang=js&"
export * from "./NoDeliveryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports